<template>
  <div class="tab__content">
    <div class="tab__content__item tab__active">
      <div class="row">
        <div class="col-lg-6">
          <h4 class="tab__content__title">{{ $lang.app.ADDITIONAL_FILES }}</h4>
          <div v-for="(additionalFile, index) in application.additionalFiles" :key="index" class="stack__list">
            <button type="button" class="file__item" @click="loadFile(application, additionalFile)">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
              </svg>
              <span class="file__item__name">
                {{ additionalFile.file.filename }}
              </span>
            </button>
          </div>
          <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_ADD_ADDITIONAL_FILES_ACTION')"
                  type="button" class="button button__icon--left mt-4"
                  @click="$emitter.emit('openApplicationAddAdditionalFilesModal', application)">
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
            </svg>
            {{ $lang.app.ADD_FILE }}
          </button>
        </div>
        <div class="col-lg-6">
          <h4 class="tab__content__title">{{ $lang.app.INITIAL_PERMIT_DOCUMENTATION }}</h4>
          <div v-for="(documentation, index) in application.initialPermitDocumentations" :key="index" class="stack__list">
            <button type="button" class="file__item" @click="loadDocumentationFile(application, documentation)">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
              </svg>
              <span class="file__item__name">
                {{ documentation.file.filename }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AddAdditionalFilesModal/>
</template>
<script>
import applicationApi from '../../../api/employee/application';
import fileMixin from "../../../mixins/fileMixin";
import AddAdditionalFilesModal from "../../../components/employee/application/modals/AddAdditionalFilesModal.vue";

export default {
  components: {
    AddAdditionalFilesModal
  },
  props: {
    application: Object
  },
  mixins: [fileMixin],
  methods: {
    loadFile(application, additionalFile) {
      this.$emitter.emit('open-loader-modal')
      applicationApi.getApplicationAdditionalFile(application.id, additionalFile.id, additionalFile.file.id)
          .then(({data})=> {
            const blob = this.base64toBlob(data.base64, data.mimeType);
            this.$emitter.emit('open-blob-file-modal', {
              file: data,
              blobFile: URL.createObjectURL(blob)
            })
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          })
    },
    loadDocumentationFile(application, documentation) {
      this.$emitter.emit('open-loader-modal')
      applicationApi.getApplicationDocumentationFile(application.id, documentation.id)
          .then(({data})=> {
            const blob = this.base64toBlob(data.base64, data.mimeType);
            this.$emitter.emit('open-blob-file-modal', {
              file: data,
              blobFile: URL.createObjectURL(blob)
            })
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          })
    }
  }
}
</script>